import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

const BillToReceivePage = () => {
  const history = useHistory();
  const match = useRouteMatch();

  useEffect(() => {
    if (match.isExact) {
      history.replace(`/app/financial/billToReceiver/releaseBillToReceiver`);
    }
  }, [match]);

  return null;
};

export default BillToReceivePage;
